<template>
  <Modal v-model="costAllocationModal" :title="$t('key1001225')" :width="costAllocationForm.chargingMode === 1 ? 600 : 1200"
    :transfer="false" :mask-closable="false" @on-visible-change="costAllocationChange">
    <Form ref="costAllocationForm" :model="costAllocationForm" :rules="currentRules" :label-width="100" @submit.native.prevent>
      <Row style="width: 90%;">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1001226')" prop="type">
            <Select v-model="costAllocationForm.type" style="width:300px;">
              <Option v-for="(item, index) in expenseTypeList" :value="item.value" :key="index">{{ item.name }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1001227')" prop="ymsWarehouseId">
            <div class="flex align-items-center">
              <Select v-model="costAllocationForm.ymsWarehouseId" filterable style="width:300px;">
                <template v-if="systemType === 'supplier'">
                  <Option v-for="item in warehouseList" :value="item.ymsWarehouseId" :label="item.name + ' ' + item.warehouseTypeName">
                    <div class="flex align-items-center justify-content-between" style="width: 95%;">
                      <span class="color-333">{{ item.name }}</span>
                      <span class="font-size-12 color-999">{{ item.warehouseTypeName }}</span>
                    </div>
                  </Option>
                </template>
                <template v-else>
                  <Option v-for="(item, index) in warehouseList" :value="item.ymsWarehouseId" :key="index">{{ item.name }}</Option>
                </template>
              </Select>
              <Tooltip max-width="500" placement="top" :content="$t('key1001228')" v-if="systemType === 'supplier'">
                <Icon type="md-information-circle" color="#2D8CF0" class="cursor ml6" size="20"/>
              </Tooltip>
            </div>
          </FormItem>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1001229')" prop="chargingMode" class="radio_styles">
            <RadioGroup v-model="costAllocationForm.chargingMode">
              <Radio :label="1" class="font-size-12">{{ $t('key1001237') }}</Radio>
              <Radio :label="3" class="font-size-12">{{ $t('key1001238') }}</Radio>
            </RadioGroup>
          </Form-item>
        </Col>
        <!--按订单商品件数收费-->
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-show="costAllocationForm.chargingMode === 1">
          <FormItem :label="$t('key1001230')" prop="packageHandlerCost">
            <InputNumber
              style="width:300px;"
              :min="0"
              :max="9999999"
              :formatter="(value) => formatterNumber(value, 2)"
              v-model.trim="costAllocationForm.packageHandlerCost">
            </InputNumber>
          </FormItem>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-show="costAllocationForm.chargingMode === 1">
          <FormItem :label="$t('key1001231')" prop="addPackageHandlerCost">
            <InputNumber
              style="width:300px;"
              :min="0"
              :max="9999999"
              :formatter="(value) => formatterNumber(value, 2)"
              v-model.trim="costAllocationForm.addPackageHandlerCost">
            </InputNumber>
          </FormItem>
        </Col>
        <h2 class="font-size-12 ml28" v-if="costAllocationForm.packageHandlerCost || costAllocationForm.addPackageHandlerCost">
          {{
            $t('key1001234') + (costAllocationForm.packageHandlerCost || 0) + ' + ' +
            (costAllocationForm.addPackageHandlerCost || 0) + $t('key1001235')
          }}
        </h2>
        <!--按订单商品重量收费-->
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-show="costAllocationForm.chargingMode === 3">
          <Form-item :label="$t('key1000548')" prop="billingMethod" class="radio_styles">
            <RadioGroup v-model="costAllocationForm.billingMethod">
              <Radio v-for="item in billingMethodList" :label="item.value" class="font-size-12">{{ item.name }}</Radio>
            </RadioGroup>
          </Form-item>
        </Col>
        <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-show="costAllocationForm.chargingMode === 3">
          <Form-item :label="$t('key1001232')" prop="freightCurrency">
            <Select v-model="costAllocationForm.freightCurrency" filterable>
              <Option v-for="(item, itemIndex) in currencyList" :key="itemIndex" :value="item.value">{{ item.label }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-show="costAllocationForm.chargingMode === 3">
          <Form-item :label="$t('key1001233')" prop="weightUnit">
            <Select v-model="costAllocationForm.weightUnit">
              <Option v-for="(item, itemIndex) in weightUnitList" :key="itemIndex" :value="item.value">{{ item.name }}</Option>
            </Select>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template v-if="costAllocationForm.chargingMode === 3">
      <!--计算公式-->
      <div class="font-size-12 mb10" v-html="calculationFormulaText"></div>
      <Table
        :highlight-row="false"
        border
        max-height="300"
        :columns="tableColumns"
        :data="tableData">
      </Table>
      <Button class="mt10 mb10" size="small" type="primary" @click="addWeightRange">{{ $t('key1001054') }}</Button>
      <p class="flex align-items-center">
        <span class="mr10">{{ $t('key1001236') + costAllocationForm.weightUnit + ')' }}</span>
        <InputNumber class="width_100" v-model="weightTest" :min="0" :max="9999999"/>
        <Button :disabled="tableData.length <=0 || !weightTest" @click="verificationProcessingFee" type="primary" class="ml10 mr10">{{ $t('key1001239') }}</Button>
        <span>{{ $t('key1000120') }}</span>
        <span>{{ freightTest }}</span>
      </p>
    </template>
    <template #footer>
      <Button @click="costAllocationModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="costAllocationBtn">{{ $t('key1000555') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import {amountHandel, formatterNumber, getCurrencyData, getDataSetBatchList, getEnumList, getWeightUnitData, isValueEmpty} from "@/utils/common";

export default {
  name: "costAllocationModal",
  mixins: [Mixin],
  props: {
    warehouseList: {
      type: Array,
      default: () => []
    },
    systemType: {
      type: String,
      default: 'yms'
    }
  },
  data() {
    let v = this;
    return {
      costAllocationModal: false,
      costAllocationForm: {
        type: 1, // 费用类型
        ymsWarehouseId: null, // 发货仓
        chargingMode: 1, // 收费模式
        billingMethod: 1, // 计费方式
        packageHandlerCost: null, // 单件处理费
        addPackageHandlerCost: null, // 续件处理费
        freightCurrency: 'CNY', // 费用币种
        weightUnit: 'g',
      },
      ruleValidate: {
        ymsWarehouseId: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001208'), trigger: 'change'}
        ],
        packageHandlerCost: [
          {type: 'number', required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001209'), trigger: 'change'}
        ],
        addPackageHandlerCost: [
          {type: 'number', required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001210'), trigger: 'change'}
        ],
        freightCurrency: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001211'), trigger: 'change'}
        ],
        weightUnit: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001212'), trigger: 'change'}
        ],
      },
      expenseTypeList: [
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001213'), value: 1},
        /*{name: '仓库处理费', value: 2},*/
      ],
      costAllocationType: 'add',
      ymsWarehousePriceModelDetails: {},
      weightUnitList: [],
      commonColumns: [
        {
          key: 'startWeight',
          minWidth: 180,
          renderHeader(h) {
            return h('span', {class: 'red-dot'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001011') + ' >（' + v.costAllocationForm.weightUnit + '）');
          },
          render: (h, params) => {
            return h('InputNumber', {
              props: {
                value: params.row.startWeight,
                disabled: params.index !== 0,
                max: 9999999,
                min: 0,
                formatter: (value) => formatterNumber(value, 2)
              },
              class: 'width_130',
              on: {
                'input': (val) => {
                  v.tableData[params.index].startWeight = val;
                }
              }
            });
          }
        },
        {
          key: 'endWeight',
          minWidth: 180,
          renderHeader(h) {
            return h('span', {class: 'red-dot'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001012') + ' <=（' + v.costAllocationForm.weightUnit + '）');
          },
          render: (h, params) => {
            return h('InputNumber', {
              props: {
                value: params.row.endWeight,
                max: 9999999,
                min: 0,
                formatter: (value) => formatterNumber(value, 2)
              },
              class: 'width_130',
              on: {
                'input': (val) => {
                  v.tableData[params.index].endWeight = val;
                  if (v.tableData[params.index + 1]) {
                    v.tableData[params.index + 1].startWeight = val;
                  }
                }
              }
            });
          }
        },
        {

          key: 'unitPrice',
          minWidth: 180,
          renderHeader(h) {
            return h('span', {class: 'red-dot'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001110') + '（' + v.costAllocationForm.freightCurrency + '）');
          },
          render(h, params) {
            return h('InputNumber', {
              props: {
                value: params.row.unitPrice,
                max: 9999999,
                min: 0,
                formatter: (value) => formatterNumber(value, 2)
              },
              class: 'width_130',
              on: {
                'input': (val) => {
                  v.tableData[params.index].unitPrice = val;
                }
              }
            });
          }
        },
        {
          key: 'firstWeight',
          minWidth: 180,
          renderHeader(h) {
            return h('span', {class: 'red-dot'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001015') + v.costAllocationForm.weightUnit + '）');
          },
          render(h, params) {
            return h('InputNumber', {
              props: {
                value: params.row.firstWeight,
                max: 9999999,
                min: 0,
                formatter: (value) => formatterNumber(value, 2)
              },
              class: 'width_130',
              on: {
                'input': (val) => {
                  v.tableData[params.index].firstWeight = val;
                }
              }
            });
          }
        },
        {
          key: 'firstWeightPrice',
          minWidth: 180,
          renderHeader(h) {
            return h('span', {class: 'red-dot'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001214') + '(' + v.costAllocationForm.freightCurrency + ')');
          },
          render(h, params) {
            return h('InputNumber', {
              props: {
                value: params.row.firstWeightPrice,
                max: 9999999,
                min: 0,
                formatter: (value) => formatterNumber(value, 2)
              },
              class: 'width_130',
              on: {
                'input': (val) => {
                  v.tableData[params.index].firstWeightPrice = val;
                }
              }
            });
          }
        },
        {
          key: 'unitWeight',
          minWidth: 180,
          renderHeader(h) {
            return h('span', {class: 'red-dot'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001019') + v.costAllocationForm.weightUnit + '）');
          },
          render(h, params) {
            return h('InputNumber', {
              props: {
                value: params.row.unitWeight,
                max: 9999999,
                min: 0,
                formatter: (value) => formatterNumber(value, 2)
              },
              class: 'width_130',
              on: {
                'input': (val) => {
                  v.tableData[params.index].unitWeight = val;
                }
              }
            });
          }
        },
        {
          key: 'unitWeightPrice',
          minWidth: 180,
          renderHeader(h) {
            return h('span', {class: 'red-dot'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001021') + '(' + v.costAllocationForm.freightCurrency + ')');
          },
          render(h, params) {
            return h('InputNumber', {
              props: {
                value: params.row.unitWeightPrice,
                max: 9999999,
                min: 0,
                formatter: (value) => formatterNumber(value, 2)
              },
              class: 'width_130',
              on: {
                'input': (val) => {
                  v.tableData[params.index].unitWeightPrice = val;
                }
              }
            });
          }
        },
        {
          renderHeader(h) {
            return h('span', {class: 'red-dot'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001215'));
          },
          key: 'costPrice',
          minWidth: 180,
          align: 'center',
          render(h, params) {
            return h('InputNumber', {
              props: {
                value: params.row.costPrice,
                max: 9999999,
                min: 0,
                formatter: (value) => formatterNumber(value, 2)
              },
              class: 'width_130',
              on: {
                'input': (val) => {
                  v.tableData[params.index].costPrice = val;
                }
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'operation',
          align: 'center',
          width: 100,
          render: (h, params) => {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    color: '#FF0000',
                    show: true,
                    clickFn: () => {
                      if (v.tableData[params.index + 1] && v.tableData[params.index - 1]) {
                        v.$set(v.tableData[params.index + 1], 'startWeight', v.tableData[params.index - 1].endWeight);
                      }
                      v.tableData.splice(params.index, 1);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableColumns: [],
      tableData: [
        {
          startWeight: 0,
          endWeight: 0,
          unitPrice: null,
          firstWeight: null,
          firstWeightPrice: null,
          unitWeight: null,
          unitWeightPrice: null,
          costPrice: null
        }
      ],
      weightTest: null,
      freightTest: 0,
      currencyList: [],
      enumData: []
    };
  },
  computed: {
    // 计费公式
    calculationFormulaText() {
      let text = '';
      switch (this.costAllocationForm.billingMethod) {
        // 普通计费
        case 1:
          text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001216');
          break;
        // 首续重计费
        case 2:
          text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001217') + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001218')
            + '<br/>'
            + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001219')
            + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001220');
          break;
        // 固定收费
        case 3:
          text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001221');
          break;
      }
      return text;
    },
    // 动态计算表单校验规则
    currentRules() {
      const baseRules = {
        ymsWarehouseId: [{required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001208'), trigger: 'change'}]
      };
      if (this.costAllocationForm.chargingMode === 1) {
        return {
          ...baseRules,
          packageHandlerCost: [{type: 'number', required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001209'), trigger: 'change'}],
          addPackageHandlerCost: [{type: 'number', required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001210'), trigger: 'change'}]
        };
      } else if (this.costAllocationForm.chargingMode === 3) {
        return {
          ...baseRules,
          freightCurrency: [{required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001211'), trigger: 'change'}],
          weightUnit: [{required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001212'), trigger: 'change'}]
        };
      }
      return baseRules;
    },

    // 当前模式需要校验的字段
    fieldsToValidate() {
      let chargingMode = this.costAllocationForm.chargingMode;
      let keyList = [];
      switch (chargingMode) {
        case 1:
          keyList = ['ymsWarehouseId', 'packageHandlerCost', 'addPackageHandlerCost'];
          break;
        case 3:
          keyList = ['ymsWarehouseId', 'freightCurrency', 'weightUnit'];
      }
      return keyList;
    },
    // 计费方式
    billingMethodList() {
      const ENUM_KEY = 'YmsLogisServicePriceModelZonePriceTypeCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number');
    }
  },
  methods: {
    formatterNumber,
    // 初始化数据
    async initCostAllocationData(type, data) {
      let enumKeyList = ['YmsLogisServicePriceModelZonePriceTypeCoreEnum'];
      this.enumData = await getDataSetBatchList(enumKeyList);
      this.currencyList = await getCurrencyData();
      this.weightUnitList = await getWeightUnitData();
      this.costAllocationType = type;
      if (data) {
        let ymsWarehousePriceModelDetails = data.ymsWarehousePriceModelDetails || [];
        if (ymsWarehousePriceModelDetails.length > 0) {
          let details = data.ymsWarehousePriceModelDetails[0];
          for (let key in this.costAllocationForm) {
            if (['type', 'ymsWarehouseId'].includes(key)) {
              this.costAllocationForm[key] = data[key];
            }
          }
          this.costAllocationForm.chargingMode = data.billingType;
          this.costAllocationForm.billingMethod = details.billingType;
          this.costAllocationForm.packageHandlerCost = details.packageHandlerCost;
          this.costAllocationForm.addPackageHandlerCost = details.addPackageHandlerCost;
          this.costAllocationForm.freightCurrency = details.currency;
          this.costAllocationForm.weightUnit = data.weightUnit;
          this.ymsWarehousePriceModelDetails = details;
          let ymsWarehousePriceModelDetailRules = details.ymsWarehousePriceModelDetailRules || [];
          if (ymsWarehousePriceModelDetailRules.length > 0) {
            let newList = [];
            ymsWarehousePriceModelDetailRules.map((item) => {
              newList.push({
                startWeight: item.start,
                endWeight: item.end,
                unitPrice: item.packageHandlerCost,
                firstWeight: item.firstWeight,
                firstWeightPrice: item.firstWeightPrice,
                unitWeight: item.unitWeight,
                unitWeightPrice: item.unitWeightPrice,
                costPrice: item.packageHandlerCost,
                ymsWarehousePriceModelDetailId: item.ymsWarehousePriceModelDetailId,
                ymsWarehousePriceModelDetailRuleId: item.ymsWarehousePriceModelDetailRuleId
              });
            });
            this.tableData = newList;
          }
        }
      }
      this.costAllocationModal = true;
    },

    // 使用 validateField 校验当前模式字段
    validateCurrentFields() {
      const fields = this.fieldsToValidate;
      let pending = fields.map(field => {
        return new Promise(resolve => {
          this.$refs.costAllocationForm.validateField(field, (error) => {
            resolve(error);
          });
        });
      });
      return Promise.all(pending).then(results => results.every(i => !i));
    },
    // 保存按钮
    costAllocationBtn() {
      let v = this;
      v.validateCurrentFields().then(valid => {
        if (valid) {
          if (v.costAllocationForm.chargingMode === 3) {
            v.validateWeightRange().then((validData) => {
              if (validData.valid) {
                handleData();
              } else {
                v.$Message.error(validData.errMes);
                return false;
              }
            });
          } else {
            handleData();
          }
        }

        function handleData() {
          let url = '';
          let method = '';
          let ymsWarehousePriceModelDetailRules = [];
          if (v.costAllocationForm.chargingMode === 3) {
            if (v.tableData.length > 0) {
              v.tableData.map((item) => {
                let packageHandlerCost = v.costAllocationForm.billingMethod === 1 ? item.unitPrice :
                  v.costAllocationForm.billingMethod === 3 ? item.costPrice : 0;
                ymsWarehousePriceModelDetailRules.push({
                  start: Number(amountHandel(item.startWeight)),
                  end: Number(amountHandel(item.endWeight)),
                  packageHandlerCost: Number(amountHandel(packageHandlerCost)),
                  type: 2, // 1每日/时  2重量区间
                  firstWeight: Number(amountHandel(item.firstWeight)) || 0,
                  firstWeightPrice: Number(amountHandel(item.firstWeightPrice)) || 0,
                  unitWeight: Number(amountHandel(item.unitWeight)) || 0,
                  unitWeightPrice: Number(amountHandel(item.unitWeightPrice)) || 0,
                });
              });
            }
          }

          let query = {
            billingType: v.costAllocationForm.chargingMode, // 计费方式 1固定计费/件  2分层计费/时  3按重量计费
            type: v.costAllocationForm.type,
            ymsWarehouseId: v.costAllocationForm.ymsWarehouseId,
            ymsWarehousePriceModelDetails: [
              {
                currency: v.costAllocationForm.chargingMode === 1 ? v.currencyState : v.costAllocationForm.freightCurrency,
                addPackageHandlerCost: v.costAllocationForm.addPackageHandlerCost || 0,
                billingType: v.costAllocationForm.chargingMode === 1 ? 1 : v.costAllocationForm.billingMethod,
                packageHandlerCost: v.costAllocationForm.packageHandlerCost || 0,
                ymsWarehousePriceModelDetailId: v.ymsWarehousePriceModelDetails.ymsWarehousePriceModelDetailId || null,
                ymsWarehousePriceModelDetailRules: ymsWarehousePriceModelDetailRules,
                ymsWarehousePriceModelId: v.ymsWarehousePriceModelDetails.ymsWarehousePriceModelId || null
              }
            ],
            weightUnit: v.costAllocationForm.weightUnit,
            ymsWarehousePriceModelId: v.ymsWarehousePriceModelDetails.ymsWarehousePriceModelId || null
          };
          if (v.costAllocationType === 'add') {
            url = api.post_ymsWarehousePriceModel;
            method = 'post';
          } else {
            url = api.put_ymsWarehousePriceModel;
            method = 'put';
          }
          v.axios[method](url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.costAllocationModal = false;
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000705'));
              v.$emit('updateData', true);
            }
          });
        }
      });
    },
    // 新增重量区间
    addWeightRange() {
      let obj = {
        startWeight: 0,
        endWeight: 0,
        unitPrice: null,
        firstWeight: null,
        firstWeightPrice: null,
        unitWeight: null,
        unitWeightPrice: null,
        costPrice: null
      };
      if (this.tableData.length === 0) {
        this.tableData.push(obj);
      } else {
        this.validateWeightRange().then((validData) => {
          if (validData.valid) {
            obj.startWeight = this.tableData[this.tableData.length - 1].endWeight;
            this.tableData.push(obj);
          } else {
            this.$Message.error(validData.errMes);
            return false;
          }
        });
      }


    },
    // 校验重量区间的数值
    validateWeightRange() {
      let billingMethod = this.costAllocationForm.billingMethod;
      return new Promise((resolve) => {
        let valid = true;
        let errMes = '';
        this.tableData.filter(i => {
          if (i.endWeight <= i.startWeight) {
            valid = false;
            errMes = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001028');
            return;
          }
          switch (billingMethod) {
            // 普通计费
            case 1:
              if (isValueEmpty(i.unitPrice)) {
                valid = false;
                errMes = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001222');
              }
              break;
            // 首续重计费
            case 2:
              if (!i.firstWeight) {
                valid = false;
                errMes = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001032');
              } else if (!i.firstWeightPrice) {
                valid = false;
                errMes = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001223');
              } else if (!i.unitWeight) {
                valid = false;
                errMes = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001034');
              } else if (!i.unitWeightPrice) {
                valid = false;
                errMes = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001035');
              }
              break;
            // 固定收费
            case 3:
              if (isValueEmpty(i.costPrice)) {
                valid = false;
                errMes = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001224');
              }
              break;
          }
        });
        resolve({
          valid: valid,
          errMes: errMes
        });
      });
    },
    // 验证处理费
    verificationProcessingFee() {
      /**
       * 普通计费：处理费 = 重量 * 单价
       * 首续重计费：重量小于等于首重---> 处理费 = 首重收费
       *                重量大于首重---> 处理费 = 首重收费 + 向上取整(总重量-首重) / 续重单位重量 * 续重单价
       * 固定收费：处理费 = 费用
       */
      let valid = false;
      let billingMethod = this.costAllocationForm.billingMethod;
      this.freightTest = 0;
      this.validateWeightRange().then((validData) => {
        if (validData.valid) {
          this.tableData.forEach(i => {
            if (this.weightTest > i.startWeight && this.weightTest <= i.endWeight) {
              valid = true;
              switch (billingMethod) {
                // 普通计费
                case 1:
                  this.freightTest = amountHandel(this.weightTest * i.unitPrice);
                  break;
                // 首续重计费
                case 2:
                  if (this.weightTest <= i.firstWeight) {
                    this.freightTest = amountHandel(i.firstWeightPrice);
                  } else {
                    let extraUnits = Math.ceil((this.weightTest - i.firstWeight) / i.unitWeight);
                    this.freightTest = amountHandel(i.firstWeightPrice + extraUnits * i.unitWeightPrice);
                  }
                  break;
                // 固定收费
                case 3:
                  this.freightTest = amountHandel(i.costPrice);
                  break;
              }
            }
          });
          if (!valid) {
            this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001010'));
            return false;
          }
        } else {
          this.$Message.error(validData.errMes);
          return false;
        }
      });
    },
    // 根据不同的计费方式展示不同的计费列表字段
    setTableColumns(value) {
      let hideKeyList = [];
      switch (value) {
        // 普通计费
        case 1:
          hideKeyList = ['firstWeight', 'firstWeightPrice', 'unitWeight', 'unitWeightPrice', 'costPrice'];
          break;
        // 首续重计费
        case 2:
          hideKeyList = ['unitPrice', 'costPrice'];
          break;
        // 固定收费
        case 3:
          hideKeyList = ['firstWeight', 'firstWeightPrice', 'unitWeight', 'unitWeightPrice', 'unitPrice'];
          break;
      }
      this.tableColumns = this.commonColumns.filter(item => !hideKeyList.includes(item.key));
      this.$forceUpdate();
    },
    // 监听弹窗
    costAllocationChange(value) {
      if (!value) {
        this.ymsWarehousePriceModelDetails = {};
        this.$refs['costAllocationForm'].resetFields();
        this.tableData = [
          {
            startWeight: 0,
            endWeight: 0,
            unitPrice: null,
            firstWeight: null,
            firstWeightPrice: null,
            unitWeight: null,
            unitWeightPrice: null,
            costPrice: null
          }
        ];
        this.weightTest = null;
        this.freightTest = 0;
      }
    }
  },
  watch: {
    'costAllocationForm.chargingMode': {
      handler(value) {
        let fieldlist = this.$refs['costAllocationForm'].fields;
        let keyList = [];
        switch (value) {
          case 1:
            keyList = ['freightCurrency', 'weightUnit'];
            break;
          case 3:
            keyList = ['packageHandlerCost', 'addPackageHandlerCost'];
        }
        fieldlist.map((item, index) => {
          if (keyList.includes(item.prop)) {
            item.resetField();
            this.$forceUpdate();
          }
        });
        console.log(this.costAllocationForm);
      },
      deep: true
    },
    'costAllocationForm.billingMethod': {
      handler(value) {
        this.optionBtnWidth = [];
        this.setTableColumns(value);
      },
      deep: true,
      immediate: true,
    }
  },
};
</script>

<style lang="less" scoped>

</style>